import User from 'Services/User';

/**
 * Work out which confirmation screen an already-registered delegate should land on.
 *
 * Returns null when there is nothing to confirm yet — no logged in user, an incomplete
 * registration, or a cancelled place — so those visitors still get the registration form
 * and the standard "Register Now" prompts.
 *
 * @param {object|null} user
 * @return {string|null}
 */
const registeredStage = (user) => {
    // Admins use the registration page to register other delegates, so their own status
    // must not replace the form.
    if (!user || user.is_admin || !user.registered_at) {
        return null;
    }

    switch (user.attendance_status) {
        case 'confirmed_in_person':
            return 'confirm-attending';
        case 'external_waitlist':
        case 'internal_waitlist':
            return 'confirm-waitlist';
        case 'virtual':
            return 'confirm-not-attending';
        case 'cancelled':
            // Cancelled delegates can register again, so send them back to the form.
            return null;
        default:
            // Rows registered before attendance_status existed only carry is_attending.
            if (user.is_attending === true) {
                return 'confirm-attending';
            }

            return user.is_attending === false ? 'confirm-not-attending' : null;
    }
};

/**
 * The same thing for whoever is logged in right now.
 *
 * @return {string|null}
 */
const currentRegisteredStage = () => registeredStage(User.loggedIn ? User.data : null);

export {
    registeredStage,
    currentRegisteredStage,
};
